module.exports = __webpack_public_path__ + "img/membership_hero.117ce123.jpg";